<template>
    <v-container fluid class="ma-0 pa-0">
        <v-dialog v-model="dialog" max-width="1000">
            <v-card>
                <v-card-title class="headline title">
                    Seleccione los campos que desea visualizar:
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="4" class="text-center">
                            <v-btn
                                @click="hideHeaders"
                            >   
                                Ocultar todos
                            </v-btn>
                        </v-col>
                        <v-col cols="4" class="text-center">
                            <v-btn
                                @click="reverseHeaders"
                            >   
                                Invertir
                            </v-btn>
                        </v-col>
                        <v-col cols="4" class="text-center">
                            <v-btn
                                @click="showAllHeaders"
                            >   
                                Mostrar todos
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col v-for="key in Object.keys(enabled_headers)" cols="6" class="text-center table-head primary--text" :key="key">
                            <v-row>
                                <v-col cols="7">
                                    <v-checkbox 
                                        v-model="enabled_headers[key]" 
                                        :label="key"
                                        @change="getHeaders()"
                                    ></v-checkbox> 
                                </v-col>
                                <v-col cols="5">
                                    <v-btn v-if="key != 'training_id'" @click="openDeleteSimulationsDialog(key)" icon>
                                        <v-icon>mdi-delete</v-icon>
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog v-model="delete_simulations_dialog" max-width="600">
            <v-card>
                <v-card-title></v-card-title>
                <v-card-text>
                    ¿Seguro que quiere borrar las simulaciones de la red neuronal {{ current_model }}?
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" outlined text class="primary-border" @click="cancelDelete()">No</v-btn>
                    <v-btn color="white" text class="primary-bckground" @click="delSimulations()">Si</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-row>
            <v-col cols="5"></v-col>
            <v-col cols="2">
                <v-btn @click="dialog = true">
                    Ocultar Headers
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <!-- {{table_data}} -->
                <v-data-table
                    :headers="headers"
                    :items="table_data"
                >
                    <template v-slot:item.training_id="{ item }">
                        <v-btn @click="goTrainingDoc(item.training_id)">
                            {{item.training_id}}
                        </v-btn>
                    </template>
                </v-data-table>
                <!-- :items="kpis_data.items" -->
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mapFields } from 'vuex-map-fields';
import { vuexPrefix } from "../store/vuex_utils";
import { mapActions } from 'vuex';

export default {
    data() {
        return {
            dialog: false,
            headers: [],
            delete_simulations_dialog: false,
            current_model: '',
        }
    },
    props: {
        table_data: {
			type: Array,
			required: true,
        },
        cdb: {
            type: Object,
            required: false,
            default: function () {
                return {};
            }
        }
    },
    computed: { 
        
        ...mapFields('kpis', [
            'kpi', 
            'kpis_data', 
        ]),
        ...mapFields('me', vuexPrefix('user_data_', ['can_see_training_documents'], 'userData.')),
        enabled_headers() {
            let enabled_headers = {};
            for (let i in this.kpis_data.headers) {
                enabled_headers[this.kpis_data.headers[i].value] = true;
            }
            return enabled_headers;
        },
    },
    methods: {
        ...mapActions({
            'deleteSimulations': 'kpis/deleteSimulations'
        }),
        getHeader(key) {
            for (let i in this.kpis_data.headers) {
                if (key == this.kpis_data.headers[i]['value']) {
                    return this.kpis_data.headers[i];
                }
            }
            return False;
        },
        getHeaders() {
            this.headers = [];
            let keys = Object.keys(this.enabled_headers);
            for (let i in keys) {
                if (this.enabled_headers[keys[i]]) {
                    let h = this.getHeader(keys[i]);
                    if (h) {
                        this.headers.push(h);
                    }
                }
            }
            // return headers;
        },
        hideHeaders() {
            for (let i in this.enabled_headers) {
                this.enabled_headers[i] = false;
            }
            this.getHeaders();

        },
        showAllHeaders() {
            for (let i in this.enabled_headers) {
                this.enabled_headers[i] = true;
            }
            this.getHeaders();
        },
        reverseHeaders() {
            for (let i in this.enabled_headers) {
                this.enabled_headers[i] = !this.enabled_headers[i];
            }
            this.getHeaders();
        },

        goTrainingDoc(id) {
            // this.user_data_can_see_training_documents = true;
            // this.$router.push('/' + this.cdb.id + '/documents/' + id);
            let routeData = this.$router.resolve({name: 'document-detail', params: {'companydb_id': this.cdb.id, 'document': id}});
            window.open(routeData.href, '_blank');
        },
        openDeleteSimulationsDialog(key) {
            this.dialog = false;
            this.delete_simulations_dialog = true;
            this.current_model = key;
        },
        delSimulations() {
            let params = { 'cdb_id': this.cdb.id, 'current_model': this.current_model };
            this.deleteSimulations(params).then(() => {
                this.delete_simulations_dialog = false;
            }).catch(err => {
                console.error(err);
                this.delete_simulations_dialog = false;
            })
        },
        cancelDelete() {
            this.delete_simulations_dialog = false;
            this.current_model = '';
        }
    },
    mounted() {
        this.getHeaders();
        this.cancelDelete();
    },
};
</script>
<style scoped>
</style>